import { render, staticRenderFns } from "./HotModuleLayout.vue?vue&type=template&id=8820b852"
import script from "./HotModuleLayout.vue?vue&type=script&lang=js"
export * from "./HotModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports